module.exports = __webpack_public_path__ + "img/product-shot_03_loading.d6e09402.jpg";